import {
  FETCH_KEG_COLLECTION_BOOKING_VENUES_REQUEST,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_SUCCESS,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_FAILURE,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_CLEAR,
  FETCH_KEG_COLLECTION_BOOKING_VENUES_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
    FETCH_KEG_COLLECTION_BOOKING_VENUES_REQUEST,
    FETCH_KEG_COLLECTION_BOOKING_VENUES_SUCCESS,
    FETCH_KEG_COLLECTION_BOOKING_VENUES_FAILURE,
    FETCH_KEG_COLLECTION_BOOKING_VENUES_CLEAR,
    FETCH_KEG_COLLECTION_BOOKING_VENUES_QUEUE
)
